import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedCounter } from './AnimatedCounter';
interface Stat {
  value: number;
  suffix?: string;
  prefix?: string;
  decimals?: number;
  label: string;
  desc: string;
  source: string;
}
const stats: Stat[] = [{
  value: 85,
  suffix: '%',
  label: 'Lower Carbon Footprint',
  desc: 'Reusable vs single-use glass packaging, full lifecycle basis',
  source: 'Zero Waste Europe, 2020'
}, {
  value: 50,
  suffix: '+',
  label: 'Reuse Cycles',
  desc: 'Achievable per asset in a returnable system',
  source: 'Ellen MacArthur Foundation'
}, {
  value: 70,
  suffix: '%',
  label: 'Less Virgin Material',
  desc: 'Required for reusable vs single-use packaging',
  source: 'UNEP, 2023'
}, {
  value: 164,
  prefix: '$',
  suffix: 'B',
  label: 'Market by 2030',
  desc: 'Projected global reusable packaging market',
  source: 'Grand View Research, 2023'
}];
export const Impact: React.FC = () => {
  return <section id="impact" className="py-32 bg-primary text-white relative gloss-dark" data-id="element-294">
      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-295">
        <div className="max-w-3xl mb-20" data-id="element-296">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-display text-4xl md:text-5xl mb-6" data-id="element-297">
            The case for circular, measured.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-white/70" data-id="element-298">
            These numbers come from independent researchers, not our marketing
            team. They are the kind of results a returnable system like ours is
            built to deliver.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10" data-id="element-299">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="text-center" data-id="element-300">
              <div className="font-mono text-4xl md:text-5xl lg:text-6xl text-leaf mb-4" data-id="element-301">
                <AnimatedCounter value={stat.value} prefix={stat.prefix} suffix={stat.suffix} decimals={0} data-id="element-302" />
              </div>
              <h4 className="font-display text-xl mb-2" data-id="element-303">{stat.label}</h4>
              <p className="text-sm text-white/60 mb-4 leading-relaxed" data-id="element-304">
                {stat.desc}
              </p>
              <div className="pt-3 border-t border-white/10" data-id="element-305">
                <p className="font-mono text-[10px] text-white/40 uppercase tracking-widest" data-id="element-306">
                  Source: {stat.source}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};